module.exports = __webpack_public_path__ + "img/rm1.f896a58d.jpg";